import React from 'react'
import styled from 'styled-components';
import {device} from '../../MainContents/Style/StyleDevice'
const TableWhitespace = styled.div`
    padding:30px 0px 30px;
    margin:30px 0px 30px;
`;
const TableMarginWid = styled.table`
    width: 90%;
    margin: auto;
    table-layout: fixed;
    word-wrap: break-word;
    display: table;
    @media ${device.laptop}{
    display: block !important;
    }
`;

const Margin = styled.div`
 margin: 30px 0px 30px;
`;

const SpecialSize = styled.th`
    max-width: 160px;
    width: 160px;
    @media ${device.laptop}{
        max-width: auto;
    width: auto;
    }
`
const LearningDetail = (props) => {
      return (
        <Margin>
        <TableWhitespace>
                      <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                      <thead>
                          <tr>
                              <SpecialSize>学年</SpecialSize>
                              <th>学習内容</th>
                          </tr>
                      </thead>  
                      <tbody>
                          <tr>
                              <td  className="align-middle">小２</td>
                              <td className="text">
                                図や絵を多く取り入れた親しみやすい教材を使い、楽しく前向きに学習します。また、3年生に向けての体験講座にもなっています。冬休みに一歩進んだ学習に取り組んでいきましょう！
                              </td>
                          </tr>
                        <tr>    
                              <td  className="align-middle">小３</td>
                              <td className="text">
                                4年生になると、本格的な受験勉強がスタートします。質にこだわった問題で、楽しみながら3年生までの総復習に取り組みます。初めて塾に通うお子様にもていねいに指導しますので、安心してお申し込みください。
                              </td>
                        </tr>
                        <tr>
                              <td  className="align-middle">小４</td>
                              <td className="text">
                                学習内容が質・量ともに大幅にアップする5年生を目前に、しっかり先を見据えて、やる気を持って始める「4年生の冬」です。知識と知識のつながりを意識して学習を進めていきます。
                              </td>
                        </tr>
                          <tr>
                              <td  className="align-middle">小５</td>
                              <td className="text">
                                入試本番まであと1年。基本的な概念を理解することが、弱点を作らず、最終的には合格につながる学力を養うことになります。じっくりとそして着実に学力の定着を図る、「5年生の冬期講座」です。
                              </td>
                          </tr>
                          <tr>
                              <td  className="align-middle">小５単科集中特訓</td>
                              <td className="text">
                                土佐中学の入試過去問(算数)を４年間分仕上げ、土佐レベルの習得を図ります。
                              </td>
                          </tr>
                          
                      </tbody>
                      
                  </TableMarginWid>
                  
      </TableWhitespace>
 </Margin>
      );
};
  

export default LearningDetail;